module.exports = __webpack_public_path__ + "static/media/persimmons.75111903.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/persimmons.png
// module id = 33
// module chunks = 0